<template>
  <div>
    <div class="form-group--inline justify-start">
      <label for="selectSortby" class="form-label">{{ bp('sortBy') }}:</label>
      <div class="select select--clear w-auto inline-block">
        <select
          id="select-sortby"
          v-model="sortKey"
          qaid="select-sortby-backorders"
          class="form-control w-auto"
          @change="$emit('update-sort-type', sortKey)"
        >
          <option
            v-for="(column, colIndex) in sortOptions"
            :key="colIndex"
            :value="column.param"
            :qaid="`sort-list.option-${column.param}`"
            >{{ column.name }}</option
          >
        </select>
        <div class="focus-indicator"></div>
      </div>
    </div>
    <div v-if="gridData && gridData.items && gridData.items.length">
      <table id="order-history-grid" class="b2b-grid b2b-grid--collapse mb-0 is-compact">
        <thead class="b2b-grid__header">
          <tr>
            <template v-for="(column, index) in getColumns()">
              <th
                :key="index"
                class="b2b-grid__cell b2b-grid__head text-xs"
                :class="[column.cssClasses]"
                :qaid="`allocatedBackorder.${column.key}Header`"
              >
                {{ column.label }}
              </th>
            </template>
          </tr>
        </thead>

        <tbody>
          <!-- Each Row -->
          <template v-for="(row, rowIndex) in paginatedData">
            <order-item
              :key="rowIndex"
              :base-properties="baseProperties"
              :archive-enabled="gridData.archiveEnabled"
              :row="row"
              :row-id="rowIndex"
              :type-id="gridData.type"
              :class="[{'bg-gray-02': (rowIndex + 1) % 2 === 0}, {'is-expanded': row.expanded}]"
              class="order-item"
              @update-data-list="updateDataList"
            ></order-item>

            <transition :key="`child-${rowIndex}`" name="fade">
              <order-item-details :row="row" :base-properties="baseProperties" />
            </transition>
          </template>
        </tbody>
      </table>
      <div class="grid-x grid-margin-x mb-5 mt-2">
        <div class="cell medium-6 large-8">
          <pagination
            v-if="gridData.pageCount > 1"
            ref="pagination"
            :page-number="gridData.pageIndex"
            :page-count="gridData.pageCount"
            @page-change="pageChange"
            @prev-page="prevPage"
            @next-page="nextPage"
          ></pagination>
        </div>
        <div class="cell medium-6 large-4">
          <div class="buttons buttons--right-for-md" :class="gridData.noItemsAreShippable ? 'hidden' : ''">
            <trek-link
              id="manage-allocated-items-link"
              button
              primary
              :href="`${encodedContextPath}/checkout/multi/allocated-items`"
            >
              <span v-html="bp('manageAllocatedItems')"></span>
            </trek-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="b2b-callout b2b-callout--secondary mb-3">
      <i class="b2b-callout__icon md-18">info</i>
      {{ bp('searchNoResults') }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import pagination from '../../../mixins/pagination';
import {mapState, mapGetters} from 'vuex';
import TrekLink from '@/components/TrekLink';
import Pagination from '@/components/Pagination';
import OrderItem from '@/components/containers/my-account/OrderItem';
import OrderItemDetails from '@/components/containers/my-account/OrderItemDetails';

export default {
  components: {TrekLink, Pagination, OrderItem, OrderItemDetails},

  mixins: [pagination],

  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    size: {
      type: Number,
      required: false,
      default: 50,
    },

    gridData: {
      type: Object,
      default: () => {},
    },

    columns: {
      type: Array,
      default: () => [],
    },
  },

  inject: ['container'],

  data() {
    return {
      pageIndex: 0,
      sortKey: 'allocated',
      sortOptions: [],
    };
  },

  computed: {
    listData() {
      return this.gridData.items;
    },

    headers() {
      return this.columns;
    },

    ...mapState('backend', ['encodedContextPath']),
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  created() {
    var ref = this;
    axios.get(`/allocated/sortOptions`).then((sortOptions) => {
      sortOptions.data.forEach(function(option) {
        if (sortOptions.data) {
          ref.sortOptions.push({name: ref.bp(option), param: option});
        }
      });
    });
  },

  provide() {
    return {
      grid: this,
      container: this.container,
    };
  },

  methods: {
    getColumns() {
      return this.columns.filter((column) => {
        if (this.consumerFriendlyMode && column.key == 'price') {
          return false;
        } else {
          return true;
        }
      });
    },

    pageChange(num) {
      this.gridData.pageIndex = num;
      this.container.fetchOrders(this.gridData.type, this.sortKey);
    },
    updateDataList() {
      this.$emit('update-data-list');
    },
  },
};
</script>
